module.exports = __webpack_public_path__ + "static/media/step4.bb330fa1.webp";